<dw-grid-list-page
  [title]="'Doc::Menu:DocTemplates' | abpLocalization"
  [activeView]="agGrid.activeView"
  (createAction)="createEntity()"
  [createActionLabel]="'::Add'"
  [enableDeleteBtn]="selectedEntities().length > 0"
  (deleteAction)="deleteEntities()"
  class="h-100"
>
  <dw-grid-ag-grid
    [columnDefs]="columns"
    [datasource]="datasource"
    (rowClicked)="rowClicked($event)"
    [(selectedRows)]="selectedEntities"
    (selectedRowsClicked)="selectedRowsClicked($event)"
    class="h-100"
    [context]="GoliathDocumentEntityNames.DocTemplate.shortName"
    #agGrid
  >
  </dw-grid-ag-grid>
</dw-grid-list-page>
